import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { snackbarVariantOptions } from '../components/stories/molecules/snackbar/constants'
import { useSnackbar } from '../components/stories/molecules/snackbar/component/snackbar-hook'
import { useCreateBulkTasksMutation } from '../react-query/bulk-operations/mutation/use-create-bulk-tasks-mutation'
import { useUpdateBulkTasksMutation } from '../react-query/bulk-operations/mutation/use-update-bulk-tasks-mutation'
import { useUpdateBulkPinsMutation } from '../react-query/bulk-operations/mutation/use-update-bulk-pins-mutation'
import { useAddBulkPinsToGroupMutation } from '../react-query/bulk-operations/mutation/use-add-bulk-pins-to-group-mutation'
import { useCreateFilterMutation } from '../react-query/filters/mutation/use-create-filter-mutation'

export const useBulkOperations = () => {
  const { formatMessage } = useIntl()
  const { addSnackbar } = useSnackbar()
  const successCallbackRef = useRef(null)

  const setBulkSuccessCallback = (callback) => {
    successCallbackRef.current = callback
  }

  const handleBulkOperationError = () => {
    const snackbarErrorOptions = {
      message: formatMessage({ id: 'bulk_operations_error_description' }),
      snackbarType: snackbarVariantOptions.ERROR
    }

    addSnackbar(snackbarErrorOptions)
  }

  const handleBulkOperationSuccess = () => {
    const snackbarSuccessOptions = {
      message: formatMessage({ id: 'bulk_operations_success_description' }),
      snackbarType: snackbarVariantOptions.INFO
    }

    successCallbackRef.current?.()

    addSnackbar(snackbarSuccessOptions)
  }

  const { mutateAsync: createFilterAsync, data: filterData } =
    useCreateFilterMutation()

  const { mutate: createBulkTasks, isPending: createBulkTasksLoading } =
    useCreateBulkTasksMutation({
      onError: handleBulkOperationError,
      onSuccess: handleBulkOperationSuccess
    })

  const { mutate: updateBulkTasks, mutateAsync: updateBulkTasksAsync } =
    useUpdateBulkTasksMutation({
      onError: handleBulkOperationError,
      onSuccess: handleBulkOperationSuccess
    })

  const { mutate: updateBulkPins } = useUpdateBulkPinsMutation({
    onError: handleBulkOperationError,
    onSuccess: handleBulkOperationSuccess
  })

  const { mutate: addBulkPinsToGroup, isPending: addBulkPinsToGroupLoading } =
    useAddBulkPinsToGroupMutation({
      onError: handleBulkOperationError,
      onSuccess: handleBulkOperationSuccess
    })

  return {
    // create filters
    createFilterAsync,
    filterData,

    // create bulk tasks
    createBulkTasks,
    createBulkTasksLoading,

    // update bulk tasks
    updateBulkTasks,
    updateBulkTasksAsync,

    // update bulk pins
    updateBulkPins,

    // add pins to group
    addBulkPinsToGroup,
    addBulkPinsToGroupLoading,
    // operation success callback
    setBulkSuccessCallback
  }
}
